export default {"src":"/_next/static/media/icon-stats-attack.070a3edf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};